
import { GameHeader } from "@/components/GameHeader";
import { Round } from "@/components/Round";
import { GameOver } from "@/components/GameOver";
import { WordPair } from "@/types/game";

interface GameCompletedStateProps {
  isDaily: boolean;
  rounds: WordPair[];
  convergenceRound: number | null;
  user: any;
  onSignInToSave: () => void;
  gameStatus: string;
}

export const GameCompletedState = ({
  isDaily,
  rounds,
  convergenceRound,
  user,
  onSignInToSave,
  gameStatus
}: GameCompletedStateProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <GameHeader isDaily={isDaily} />
      
      <main className="container mx-auto flex flex-col items-center justify-start py-16 px-4 mt-14">
        <div className="w-full max-w-3xl animate-fadeIn">
          <div className="space-y-8">
            {rounds.map((round, index) => (
              <Round
                key={index}
                userWord={round.userWord}
                aiWord={round.aiWord}
                aiExplanation={round.aiExplanation}
                proximityScore={round.proximityScore}
                isRevealed={true}
                roundNumber={index + 1}
                isLastRound={index === rounds.length - 1}
                isLastChance={index + 1 === 10} // Using 10 as MAX_ROUNDS
              />
            ))}

            <GameOver 
              convergenceRound={convergenceRound}
              roundsLength={rounds.length}
              user={user}
              onSignInToSave={onSignInToSave}
              gameStatus={gameStatus}
              rounds={rounds}
            />
          </div>
        </div>
      </main>
    </div>
  );
};
